// src/components/NavBar/MobileNavBar.jsx
import React, { useState } from "react";
import { Link } from "react-router-dom";
import "./MobileNavBar.css";
import { getStoredData } from "../../api/fetchData.jsx";

const MobileNavBar = ({
  navData = [],
  logo,
  username,
  onLogout,
  onProfile,
}) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isClosing, setIsClosing] = useState(false);

  const toggleMenu = () => {
    if (isMenuOpen) {
      setIsClosing(true);
      setTimeout(() => {
        setIsMenuOpen(false);
        setIsClosing(false);
      }, 300); // match CSS animation
    } else {
      setIsMenuOpen(true);
    }
  };

  const data = getStoredData();
  const totalData = data?.[0];

  const safeNavItems = Array.isArray(navData) ? navData : [];

  // Helper to run action items (logout/profile) and close menu
  const handleActionClick = (handler) => {
    if (typeof handler === "function") {
      toggleMenu(); // closes menu (with animation)
      handler();
    }
  };

  return (
    <div className="mobile-nav">
      <div className="mobile-header">
        {logo && (
          <Link to="/">
            <img
              src={totalData?.CompanyLogo || logo}
              alt="Logo"
              className="mobile-logo"
            />
          </Link>
        )}

        {/* Optional: show username on the right side of header */}
        {username && <span className="mobile-username">{username}</span>}

        <div className="mobile-menu-toggle" onClick={toggleMenu}>
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>

      {isMenuOpen && (
        <div className={`mobile-menu ${isClosing ? "closing" : ""}`}>
          <button className="close-menu-btn" onClick={toggleMenu}>
            &times;
          </button>

          <ul>
            {safeNavItems.map((item, index) => {
              if (!item) return null;

              const action = item.onClick;
              const link =
                typeof item.link === "string" ? item.link.trim() : "";
              const hasLink = !!link;
              const isExternal = hasLink && /^https?:\/\//i.test(link);

              // 🔹 1) ACTION ITEMS (logout / profile etc.)
              if (action === "logout" || action === "profile") {
                const handler = action === "logout" ? onLogout : onProfile;

                // If no handler passed, skip to avoid errors
                if (!handler) return null;

                const Icon = item.icon?.startsWith("fa-") ? (
                  <i className={`fas ${item.icon} MobileMenu-icon`} />
                ) : item.icon ? (
                  <img src={item.icon} alt="" className="MobileMenu-icon" />
                ) : null;

                return (
                  <li key={index}>
                    <button
                      type="button"
                      className="mobile-menu-action"
                      onClick={() => handleActionClick(handler)}
                    >
                      {Icon}
                      <span>
                        {item.name ||
                          (action === "logout" ? "Logout" : "Profile")}
                      </span>
                    </button>
                  </li>
                );
              }

              // 🔹 2) LABEL ONLY (no link / no action)
              if (!hasLink) {
                return (
                  <li key={index} className="mobile-menu-label">
                    <span>{item.name || "Untitled"}</span>
                  </li>
                );
              }

              // 🔹 3) NORMAL NAV ITEMS (internal / external links)
              const Icon = item.icon?.startsWith("fa-") ? (
                <i className={`fas ${item.icon} MobileMenu-icon`} />
              ) : item.icon ? (
                <img src={item.icon} alt="" className="MobileMenu-icon" />
              ) : null;

              return (
                <li key={index}>
                  {isExternal ? (
                    <a
                      href={link}
                      target="_blank"
                      rel="noopener noreferrer"
                      onClick={toggleMenu}
                    >
                      {Icon}
                      <span>{item.name}</span>
                    </a>
                  ) : (
                    <Link to={link} onClick={toggleMenu}>
                      {Icon}
                      <span>{item.name}</span>
                    </Link>
                  )}
                </li>
              );
            })}
          </ul>
        </div>
      )}
    </div>
  );
};

export default MobileNavBar;
